import * as React from 'react';

import { ReportTypes } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

import { MCAnswerContent, ReportOptionType } from '../ReportOption';
import {
  AssessmentsCommonProps,
  AssessmentsExportReportsPanel,
} from './AssessmentsExportReportsPanel';

const AssessmentsExportReportsCompleteResults = (
  props: AssessmentsCommonProps
) => {
  const reportOptions: ReportOptionType[] = [MCAnswerContent];
  return (
    <AssessmentsExportReportsPanel
      {...props}
      description={translate(
        'Export an Excel file of responses and scores for all students who took part in the activity.'
      )}
      title={translate('Complete Results Excel')}
      reportOptions={reportOptions}
      initialOptions={props.initialOptions}
      reportRequestSelectedType={ReportTypes.WholeClassExcel}
    />
  );
};

export { AssessmentsExportReportsCompleteResults };
export default AssessmentsExportReportsCompleteResults;
